import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const CancelModalBumper = ({
    setCancelModalVisible,
    cancelEdit,
    form,
    pristine,
}) => {
    return (
        <Modal className="text-light text-center" centered isOpen>
            <ModalHeader></ModalHeader>
            <ModalBody>
                <h5>
                    If you cancel, you will lose your changes.
                    <br />
                    Continue?
                </h5>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="info"
                    onClick={() => setCancelModalVisible(false)}>
                    Cancel
                </Button>
                <Button
                    color="danger"
                    onClick={() => cancelEdit(form, pristine, true)}>
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default CancelModalBumper;
